/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CaseV2CancelCommandResponse
 */
export interface CaseV2CancelCommandResponse {
	/**
	 *
	 * @type {boolean}
	 * @memberof CaseV2CancelCommandResponse
	 */
	isSuccessful?: boolean;
	/**
	 *
	 * @type {string}
	 * @memberof CaseV2CancelCommandResponse
	 */
	caseId?: string | null;
}

/**
 * Check if a given object implements the CaseV2CancelCommandResponse interface.
 */
export function instanceOfCaseV2CancelCommandResponse(
	value: object
): value is CaseV2CancelCommandResponse {
	return true;
}

export function CaseV2CancelCommandResponseFromJSON(json: any): CaseV2CancelCommandResponse {
	return CaseV2CancelCommandResponseFromJSONTyped(json, false);
}

export function CaseV2CancelCommandResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CaseV2CancelCommandResponse {
	if (json == null) {
		return json;
	}
	return {
		isSuccessful: json['isSuccessful'] == null ? undefined : json['isSuccessful'],
		caseId: json['caseId'] == null ? undefined : json['caseId'],
	};
}

export function CaseV2CancelCommandResponseToJSON(json: any): CaseV2CancelCommandResponse {
	return CaseV2CancelCommandResponseToJSONTyped(json, false);
}

export function CaseV2CancelCommandResponseToJSONTyped(
	value?: CaseV2CancelCommandResponse | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		isSuccessful: value['isSuccessful'],
		caseId: value['caseId'],
	};
}
